
export const CHUONGTRINH_KIEU_ENUM = {
  CK_CODINH_THEO_NHOM: 1,
  CK_CODINH_THEO_NHOM_TEXT: "Chiết khấu cố định theo nhóm",
  CK_THEM_THEO_SP: 2,
  CK_THEM_THEO_SP_TEXT: "Chiết khấu thêm theo sản phẩm",
  // CK_TANG_HANG: 3,
  // CK_TANG_HANG_TEXT: "Tặng hàng",
  CK_THEO_DON: 4,
  CK_THEO_DON_TEXT: "Chiết khấu theo đơn",
  CK_THEM_THEO_NHOM: 5,
  CK_THEM_THEO_NHOM_TEXT: "Chiết khấu thêm theo nhóm",
  THUONG_DOANH_SO: 6,
  THUONG_DOANH_SO_TEXT: "Thưởng d/số cho nhân viên",
  KHONG_CK:9,
  KHONG_CK_TEXT: "Không chiết khấu"
}

export const CHUONGTRINH_LIST_INITING             = 'CHUONGTRINH_LIST_INITING'
export const CHUONGTRINH_LIST_REQUESTING          = 'CHUONGTRINH_LIST_REQUESTING'
export const CHUONGTRINH_LIST_SUCCESS             = 'CHUONGTRINH_LIST_SUCCESS'
export const CHUONGTRINH_LIST_ERROR               = 'CHUONGTRINH_LIST_ERROR'   

export const CHUONGTRINH_NGANHHANG_LIST_INITING    = 'CHUONGTRINH_NGANHHANG_LIST_INITING'
export const CHUONGTRINH_NGANHHANG_LIST_REQUESTING = 'CHUONGTRINH_NGANHHANG_LIST_REQUESTING'
export const CHUONGTRINH_NGANHHANG_LIST_SUCCESS    = 'CHUONGTRINH_NGANHHANG_LIST_SUCCESS'
export const CHUONGTRINH_NGANHHANG_LIST_ERROR      = 'CHUONGTRINH_NGANHHANG_LIST_ERROR'   

export const CHUONGTRINH_PRODUCT_LIST_INITING    = 'CHUONGTRINH_PRODUCT_LIST_INITING'
export const CHUONGTRINH_PRODUCT_LIST_REQUESTING = 'CHUONGTRINH_PRODUCT_LIST_REQUESTING'
export const CHUONGTRINH_PRODUCT_LIST_SUCCESS    = 'CHUONGTRINH_PRODUCT_LIST_SUCCESS'
export const CHUONGTRINH_PRODUCT_LIST_ERROR      = 'CHUONGTRINH_PRODUCT_LIST_ERROR'

export const CHUONGTRINH_DETAIL_INITING           = 'CHUONGTRINH_DETAIL_INITING'
export const CHUONGTRINH_DETAIL_REQUESTING        = 'CHUONGTRINH_DETAIL_REQUESTING'
export const CHUONGTRINH_DETAIL_SUCCESS           = 'CHUONGTRINH_DETAIL_SUCCESS'
export const CHUONGTRINH_DETAIL_ERROR             = 'CHUONGTRINH_DETAIL_ERROR'   

export const CHUONGTRINH_UPDATE_REQUESTING        = 'CHUONGTRINH_UPDATE_REQUESTING'
export const CHUONGTRINH_UPDATE_SUCCESS           = 'CHUONGTRINH_UPDATE_SUCCESS'
export const CHUONGTRINH_UPDATE_ERROR             = 'CHUONGTRINH_UPDATE_ERROR'   

export const CHUONGTRINH_UPDATE_PRODUCT_REQUESTING        = 'CHUONGTRINH_UPDATE_PRODUCT_REQUESTING'
export const CHUONGTRINH_UPDATE_PRODUCT_SUCCESS           = 'CHUONGTRINH_UPDATE_PRODUCT_SUCCESS'
export const CHUONGTRINH_UPDATE_PRODUCT_ERROR             = 'CHUONGTRINH_UPDATE_PRODUCT_ERROR'   

export const CHUONGTRINH_LIST_NHOM_KH_REQUESTING          = 'CHUONGTRINH_LIST_NHOM_KH_REQUESTING'

export const CHUONGTRINH_DETAIL_API               = '/api/v1/chuongtrinh/chuongtrinh_detail_by_id'  
export const CHUONGTRINH_LIST_API                 = '/api/v1/chuongtrinh/chuongtrinh_list_by_store'   
export const CHUONGTRINH_UPDATE_API               = '/api/v1/chuongtrinh/chuongtrinh_update_by_id' 
export const CHUONGTRINH_DVT_LIST_API             = '/api/v1/management/dvt_list_by_store' 
export const CHUONGTRINH_NGANHHANG_LIST_API       = '/api/v1/management/nganhhang_list_by_store'
export const CHUONGTRINH_PRODUCT_LIST_API         = '/api/v1/chuongtrinh/chuongtrinh_product_list_by'
export const CHUONGTRINH_UPDATE_PRODUCT_API       = '/api/v1/chuongtrinh/chuongtrinh_update_product'
export const CHUONGTRINH_LIST_NHOM_KH_API         = '/api/v1/khachhang/list_nhom_kh_by_store'


export const CHUONGTRINH_LIST_KIEU                =  [
  {
    name: CHUONGTRINH_KIEU_ENUM.CK_CODINH_THEO_NHOM_TEXT,
    node: "Chương trình giúp tạo chiết khấu cố định cho các sản phầm đã chọn, nếu không nằm trong chương trình thì sản phẩm sẽ được ck theo điểm hệ số",
    id: CHUONGTRINH_KIEU_ENUM.CK_CODINH_THEO_NHOM
  },
  {
    name: CHUONGTRINH_KIEU_ENUM.KHONG_CK_TEXT,
    note: "Khi sản phầm không nằm trong chương trình ck cố định theo nhóm thì sản phầm sẽ được ck dựa theo điểm, chương trình này tạo ra để loại bỏ sản phẩm này vừa không chiết khấu cố định vừa không chiết khấu theo điểm ",
    id: CHUONGTRINH_KIEU_ENUM.KHONG_CK
  },
  {
    name: CHUONGTRINH_KIEU_ENUM.CK_THEM_THEO_SP_TEXT,
    note: "Tạo chương trình để ck cho 1 sản phẩm cụ thể nằm trong chươgn trình",
    id: CHUONGTRINH_KIEU_ENUM.CK_THEM_THEO_SP
  },
  // {
  //   name: CHUONGTRINH_KIEU_ENUM.CK_TANG_HANG_TEXT,
  //   id: CHUONGTRINH_KIEU_ENUM.CK_TANG_HANG
  // },
  {
    name: CHUONGTRINH_KIEU_ENUM.CK_THEO_DON_TEXT,
    note: "Chiết khấu theo doanh số bán trước ck của đơn, khi đơn đạt doanh số tối thiểu",
    id: CHUONGTRINH_KIEU_ENUM.CK_THEO_DON
  },
  {
    name: CHUONGTRINH_KIEU_ENUM.CK_THEM_THEO_NHOM_TEXT,
    note: "Chiết khấu theo nhóm sản phẩm, nếu sản phẩm nằm trong nhóm thì sẽ được giảm",
    id: CHUONGTRINH_KIEU_ENUM.CK_THEM_THEO_NHOM
  },
  {
    name: CHUONGTRINH_KIEU_ENUM.THUONG_DOANH_SO_TEXT,
    note: "Thưởng thêm cho nhân viên nếu bán được sản phầm đã chọn ở khu vực quy định",
    id: CHUONGTRINH_KIEU_ENUM.THUONG_DOANH_SO
  },
]



// WEBPACK FOOTER //
// ./src/views/ChuongTrinh/constants.js